<template>
  <div class="content">
    <div class="md-layout">

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
        <stats-card data-background-color="green">

          <template slot="header">
            <md-icon>store</md-icon>
          </template>

          <template slot="content">
            <p class="category">Revenue</p>
            <h3 class="title">$ {{revenue}}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>date_range</md-icon>
              accumulated earnings
            </div>
          </template>

        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
        <stats-card data-background-color="purple">

          <template slot="header">
            <md-icon>info_outline</md-icon>
          </template>

          <template slot="content">
            <p class="category">Revenue</p>
            <h3 class="title">$ {{monthRevenue}}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>alarm</md-icon>
              This month
            </div>
          </template>

        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
        <stats-card data-background-color="blue">

          <template slot="header">
            <md-icon>info_outline</md-icon>
          </template>

          <template slot="content">
            <p class="category">Week by week</p>
            <h3 class="title">{{weekly}}%</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>
              progress
            </div>
          </template>

        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
        <chart-card
          :chart-data="dailySalesChart.data"
          :chart-options="dailySalesChart.options"
          :chart-type="'Line'"
          data-background-color="blue">

          <template slot="content">
            <h4 class="title">Vouchers sold the last week</h4>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>count</md-icon>
               {{total}} sold so far
            </div>
          </template>

        </chart-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
        <chart-card
          :chart-data="dataCompletedTasksChart.data"
          :chart-options="dataCompletedTasksChart.options"
          :chart-type="'Line'"
          data-background-color="green">

          <template slot="content">
            <h4 class="title">Weekly compare</h4>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>
              Your progress for the last 7 days vs previous 7 days
            </div>
          </template>

        </chart-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="orange">
            <h4 class="title">Unconfirmed Sales</h4>
            <p class="category">This vouchers are sold but not collected</p>
          </md-card-header>
          <md-card-content>
            <ordered-table table-header-color="orange" :unconfirmed="unconfirmed"> </ordered-table>
          </md-card-content>
        </md-card>
      </div>

    </div>

  </div>
</template>

<script>

import {
  StatsCard,
  ChartCard,
  NavTabsCard,
  NavTabsTable,
  OrderedTable
} from "@/components";
import firebase from "../Firebase";

export default {
  components: {
    StatsCard,
    ChartCard,
    NavTabsCard,
    NavTabsTable,
    OrderedTable
  }, created() {
      firebase.auth().onAuthStateChanged(usr => {
          if (usr){
              firebase.firestore().collection("orders").where('seller', '==', usr.uid)
                  .get().then( querySnapshot => {

                      let date = new Date();
                      this.revenue = 0;
                      this.monthRevenue = 0;
                      let lastWeek = 1, lastWeekButOne = 1;
                      let chart = [0,0,0,0,0,0,0];
                      querySnapshot.forEach(document => {

                          let cost = (document.data()["offer"] * document.data()["quantity"]);

                          this.revenue += cost;

                          let docDate = new Date(document.data()["date"].seconds*1000);
                          if (docDate.getMonth() === date.getMonth()){
                              this.monthRevenue += cost;
                          }

                          if (docDate.getMilliseconds()> (date.getMilliseconds()-1209600000)){
                              if (docDate.getMilliseconds()> (date.getMilliseconds()-604800000)){
                                  lastWeek += cost;
                                  chart[docDate.getDay()-1] += 1;
                              }else{
                                  lastWeekButOne += cost;
                              }
                          }

                          if (!document.data()["collected"])
                              this.unconfirmed.push(document.data());
                          this.weekly = (lastWeek-lastWeekButOne)/lastWeekButOne*100;
                          this.total += 1;
                          this.dailySalesChart.data.series[0] = chart;

                      })

              });

          }
      })
    //get the total for all transactions
    //get total for this month
    //get total and array for last 7 days
    //get total and array for last last 7 days
    //filter transactions that are not marked as complete
  },
  data() {
    return {
      revenue: 0,
      monthRevenue : 0,
      weekly : 0,
      total : 0,
      unconfirmed : [],
      dailySalesChart: {
        data: {
          series: []
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 5, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      dataCompletedTasksChart: {
        data: {
          series: [
            //[230, 750, 450, 300, 280, 240, 200, 190],
            //[200, 650, 350, 400, 220, 250, 300, 290]
          ]
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      }
    };
  }
};
</script>
